import React from 'react' 
import Slider from "react-slick";

export default function Partners() {
    let settings = {
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 6,
  
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 1
          }
        }]
      };

  return (
    <>
      <section className="position-relative p70 pb-0">
    <div className="container position-relative zindex">
      <h2 className="hadding ttu text-center mb-4">
        PREVIOUS <span className="color1">PARTNERS </span>
      </h2>
      
      <Slider {...settings}>
        <div className="item">
          <div className="logosbox">
            <img src="img/icoholder.png" alt="Logo" className="img-fluid" />
          </div>
        </div>
        <div className="item">
          <div className="logosbox">
            <img
              src="img/the-coin-Republic.jpg"
              alt="Logo"
              className="img-fluid"
            />
          </div>
        </div>
        <div className="item">
          <div className="logosbox">
            <img src="img/icoholder.png" alt="Logo" className="img-fluid" />
          </div>
        </div>
        <div className="item">
          <div className="logosbox">
            <img
              src="img/the-coin-Republic.jpg"
              alt="Logo"
              className="img-fluid"
            />
          </div>
        </div>
        <div className="item">
          <div className="logosbox">
            <img src="img/icoholder.png" alt="Logo" className="img-fluid" />
          </div>
        </div>
        <div className="item">
          <div className="logosbox">
            <img
              src="img/the-coin-Republic.jpg"
              alt="Logo"
              className="img-fluid"
            />
          </div>
        </div>
      </Slider>
     
     
    </div>
  </section>
    </>
  )
}
